export default __webpack_public_path__ + "static/media/dsp-breakdown-example.4f2dc6a8.png";